
import {defineComponent, reactive, ref} from 'vue'
import {VueDraggableNext} from 'vue-draggable-next'
import {mapState} from "vuex";
import fetch from '../../services/fetch'
import post from '../../services/fetch'
import timestamp from "/@src/components/shared/Timestamp.vue";

interface GroupForm {
  creator: Number,
  name: Text,
  description: Text,
  user_list: Array<Number>,
  strats_list: Array<Number>,
}

interface AllGroups {
  id: number,
  name: String,
  user_list: [],
  strats_list: [],
}

interface CustomGroupListI {
  [key: number]: Record<string, any>[],
}

interface AllUsersList {
  id: number,
  first_name: String,
  last_name: String,
}

interface AllStrats {
  id: number,
  strat_name: string,
  is_active: boolean,
  trader: number,
  creator: number,
  is_yield: boolean,
  chart: boolean,
  created_at: Date,
}

interface Data {
  form: GroupForm[],
  all_groups: AllGroups[],
  all_users: AllUsersList[],
  all_strats: AllStrats[],
  //group: AllGroups[],
  CustomGroupListI: [],
  headers: any,
}

export const group = reactive<AllGroups>({
  id: 0,
  name: '',
  user_list: [],
  strats_list: [],
})

export default defineComponent({
  name: 'GroupPageBuilder',
  components: {
    draggable: VueDraggableNext,
  },

  data() {
    return {
      form: [] as GroupForm[],
      all_groups: [] as AllGroups[],
      all_users: [] as AllUsersList[],
      all_strats: [] as AllStrats[],
      AllStratsP: [] as AllStrats[],
      CustomStratListP: [] as AllStrats[],
      CustomGroupListI: [],
      group: ref(group),
      headers: {
        'Content-Type': "application/json",
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    }
  },
  computed: {
    ...mapState(['user', 'group_id']),
  },
  created() {
    this.loadSettings()
    this.loadSettingsStrats(9999999999)
  },

  methods: {
    loadSettingsStrats(group_id: any) {
      const params = new URLSearchParams({
        group_id: group_id,
      }).toString();
      fetch
          .get('/group_list?' + params)
          .then(response => {
            for (let i = 0; i < response.data['all_strats'].length; i++) {
              switch (response.data['all_strats'][i].is_active) {
                case true:
                  this.AllStratsP.push({
                    id: response.data['all_strats'][i].id,
                    strat_name: response.data['all_strats'][i].strat_name,
                    is_active: response.data['all_strats'][i].is_active,
                    trader: response.data['all_strats'][i].trader,
                    creator: response.data['all_strats'][i].creator,
                    is_yield: response.data['all_strats'][i].is_yield,
                    chart: response.data['all_strats'][i].chart,
                    created_at: response.data['all_strats'][i].created_at,
                  });

                  break;
                default:
                  this.AllStratsP.push({
                    id: response.data[i].id,
                    strat_name: response.data[i].strat_name,
                    is_active: response.data[i].is_active,
                    trader: response.data[i].trader,
                    creator: response.data[i].creator,
                    is_yield: response.data[i].is_yield,
                    chart: response.data[i].chart,
                    created_at: response.data[i].created_at,
                  });
                  break;

              }
            }
            let strats_list = response.data['g_strat_list'][0]['strats_list']
            for (let i = 0; i < strats_list.length; i++) {
              switch (strats_list[i].is_active) {
                case true:
                  this.CustomStratListP.push({
                    id: strats_list[i].id,
                    strat_name: strats_list[i].strat_name,
                    is_active: strats_list[i].is_active,
                    trader: strats_list[i].trader,
                    creator: strats_list[i].creator,
                    is_yield: strats_list[i].is_yield,
                    chart: strats_list[i].chart,
                    created_at: strats_list[i].created_at,
                  });

                  break;
                default:
                  this.CustomStratListP = [];

              }

            }
            for (let i = this.AllStratsP.length - 1; i >= 0; i--) {
              for (let j = 0; j < this.CustomStratListP.length; j++) {
                if (this.AllStratsP[i] && (this.AllStratsP[i].strat_name === this.CustomStratListP[j].strat_name)) {
                  this.AllStratsP.splice(i, 1);
                }
              }
            }

          });
    },
    loadSettings() {
      const params = new URLSearchParams({
        group_id: this.group_id,
      }).toString();
      fetch
          .get('/group_list?' + params)
          .then(response => {
                for (let i = 0; i < response.data['all_groups'].length; i++) {
                  this.all_groups.push({
                    id: response.data['all_groups'][i]['id'],
                    name: response.data['all_groups'][i]['name'],
                    user_list: response.data['all_groups'][i]['user_list'],
                    strats_list: response.data['all_groups'][i]['strats_list'],
                  })
                  // this.CustomGroupListI[response.data['all_groups']?[i]?['id']?]? = []
                }

                for (let i = 0; i < response.data['all_users'].length; i++) {
                  this.all_users.push({
                    id: response.data['all_users'][i]['id'],
                    first_name: response.data['all_users'][i]['first_name'],
                    last_name: response.data['all_users'][i]['last_name'],
                  })
                }
                this.all_groups.push(response.data['all_strats']);
              }
          );
    },
    fieldUpdate(event: Event): void {

      const target = event.target as HTMLInputElement
      this.group_id = parseInt(target.value)
      this.loadSettingsStrats(parseInt(target.value))
      this.CustomStratListP = []
      const [group, ...tail] = this.all_groups.filter((group_data) => {
        if (group_data.id === parseInt(target.value)) {
          this.group.id = group_data.id,
              this.group.name = group_data.name
          //console.log('LENGHT:::',group_data.user_list.length)
          if (group_data.user_list != null && group_data.user_list.length > 0) {
            for (let i = 0; i < group_data.user_list.length; i++) {
              this.CustomGroupListI.push(group_data.user_list[i])
            }
          } else {
            this.CustomGroupListI = []
          }
          return {
            'id': group_data.id,
            'name': group_data.name,
          }

        }
      })
      //this.all_groups.map((group) => group.id===parseInt(target.id) ? group.name = target.value : group.name)
      //this.form[ target.name ] = target.value
    },
    statusChangeStrat(event: any, param: any) {
      if (event == 'added' || event == 'sorted') {
        let json = {};
        let status = '';
        switch (param) {
          case 3:
            let CustomStratListP: any = [];
            CustomStratListP.push(...this.CustomStratListP.map(emp => emp['id']));
            json = JSON.stringify({
              'list_of_strats': CustomStratListP,
              'group': this.group.id,
            });
            status = 'Added Strats to the group';
            break;
        }

        post(`/group_list/strats/update`, json)
            .then((response) => {
            })
            .catch((error) => {
            });
      }
    },

  },
})
